module.exports = "{{ project.name }} ({{ project.id }})\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/project-info-small/project-info-small.component.html
// module id = ./src/app/shared/project-info-small/project-info-small.component.html
// module chunks = main